import { StepId } from './flow';

export const FLOW_NAME_PREFIX = 'stores-onboarding';

export const BI_STEP_NAME: Record<StepId, string> = {
  [StepId.LandingPage]: `${FLOW_NAME_PREFIX}.landing-page`,
  [StepId.SelectStoreType]: `${FLOW_NAME_PREFIX}.select-store-type`,
  [StepId.SelectSellingType]: `${FLOW_NAME_PREFIX}.select-selling-type`,
  [StepId.SelectCategory]: `${FLOW_NAME_PREFIX}.select-category`,
  [StepId.SelectCatalogSize]: `${FLOW_NAME_PREFIX}.select-catalog-size`,
  [StepId.SelectTemplate]: `${FLOW_NAME_PREFIX}.select-template`,
  [StepId.SelectSiteName]: `${FLOW_NAME_PREFIX}.select-site-name`,
  [StepId.SiteSetup]: `${FLOW_NAME_PREFIX}.site-setup`,
  [StepId.SiteReady]: `${FLOW_NAME_PREFIX}.site-ready`,
  [StepId.CurrentPlatform]: `${FLOW_NAME_PREFIX}.current-platform`,
  [StepId.CreateProductUpload]: `${FLOW_NAME_PREFIX}.create-product-upload`,
  [StepId.CreateProductForm]: `${FLOW_NAME_PREFIX}.create-product-form`,
} as const;

export const BI_ACTION_NAME = {
  NEXT: 'next',
  BACK: 'back',
  SKIP: 'skip',
} as const;

export const BI_BUTTON_NAME = {
  OPTION_SELECTED: 'option_selected',
  START_NOW: 'start_now',
} as const;
